import $ from 'jquery';

const defaults = {
  selector: '.node-inner',
};

function Redirect(element, options) {
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.listen();
}

Redirect.prototype = {
  listen() {
    this.$element.find(this.settings.selector).on('click', this.click);
  },
  click(event) {
    event.preventDefault();
    event.stopPropagation();
    const url = $(event.currentTarget).find('.link-read-more a').attr('href');
    location.href = url;
  },
};

export default Redirect;



// WEBPACK FOOTER //
// ./Redirect.js